var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { AppBar, Box, Chip, Toolbar, Typography } from '@mui/material';
import { SupHeader, BetaChip } from './Header.styles';
var Header = function (props) {
    var title = props.title, chip = props.chip;
    return (_jsxs(Box, __assign({ sx: { flexGrow: 1 } }, { children: [chip && (_jsxs(SupHeader, { children: [_jsx(Chip, { color: "primary", css: BetaChip.chip, label: chip }), _jsx(Typography, { variant: "body2" })] })), _jsx(AppBar, __assign({ position: "relative", sx: { boxShadow: 0 } }, { children: _jsx(Toolbar, { children: _jsx(Typography, __assign({ variant: "h4", component: "div", sx: { flexGrow: 1 } }, { children: title })) }) }))] })));
};
export default Header;
